import React from 'react';
import { Box, Typography } from '@mui/material';
import useStyles from '../styles';
import { CardPriceType } from '../types';
import { formatCcy } from '../../../utils/helpers';

function CardPrice({
  title,
  originalPrice,
  discountType,
  discountPrice,
  finalPrice,
}: CardPriceType) {
  const classes = useStyles();
  return (
    <Box>
      <Typography className={classes.innerSectionTitle}>
        {title}
      </Typography>
      <Box className={classes.priceContainer}>
        {discountPrice > 0 && (
          <>
            <Typography className={classes.originalPrice}>
              {formatCcy(originalPrice, '.')}
            </Typography>
            <Typography className={classes.discountPrice}>
              {discountType === 'percentage' ? `${formatCcy(discountPrice, '.')}% OFF` : `${formatCcy(discountPrice, '.')} OFF`}
            </Typography>
          </>
        )}
      </Box>
      <Typography className={classes.programFinalPrice}>
        {formatCcy(finalPrice, '.')}
      </Typography>
    </Box>
  );
}

export default CardPrice;
